import { useEffect } from 'react';
import { updateExportDataAtom } from './atom';
import { useSetAtom } from 'jotai';

function useSetExport({ pageKey, sectionKey, widgetKey, widgetInfo, headers, data }) {
  const updateExportData = useSetAtom(updateExportDataAtom);

  useEffect(() => {
    const path = ['sections', sectionKey, widgetKey];

    // TODO: test for overwrite issues
    updateExportData({ action: '$set', path, data: { widgetInfo, headers, data } });

    // remove data on unmount
    return () => {
      updateExportData({ action: '$unset', path });
    };
  }, [sectionKey, widgetKey, widgetInfo, headers, data, updateExportData]);
}

export default useSetExport;
